<template>
  <div class="page-content set egl-dialog-elm original-dialog">
    <h1 class="page-title">{{ $locale("sideMenu.shop.set") }}</h1>

    <!-- Search Area -->
    <el-row class="search-area">
      <el-col :span="14">
        <el-row>
          <el-col :span="10" class="search-item">
            <el-input
              :placeholder="$locale('form.plsEnterYourName')"
              v-model="searchValue"
              @keyup.enter.native="search(searchValue)"
            >
              <i slot="suffix" class="el-input__icon el-icon-search" @click="search(searchValue)"></i>
            </el-input>
          </el-col>
          <el-col :span="4" class="search-item">
            <el-button class="egl-btn-yellow" @click="search(searchValue)">{{$locale("global.search")}}</el-button>
          </el-col>
        </el-row>
      </el-col>
      <el-col :span="10" class="search-item ta-r">
        <el-button class="egl-btn-gray" disabled v-if="getApproveItem">{{$locale("global.approve")}}</el-button>
        <el-button class="egl-btn-yellow" @click="approve_fn" v-else>{{$locale("global.approve")}}</el-button>
        <el-button class="egl-btn-yellow" @click="openDialog('C')">{{$locale("global.create")}}</el-button>
      </el-col>
    </el-row>

    <el-table
      style="width: 100%"
      :data="tableData"
      :stripe="true"
      ref="tableRef"
      @sort-change="sortChange"
      @filter-change="filterHandler"
      class="egl-table list-table"
    >
      <el-table-column
        :label="$locale('global.change')"
        prop="approve"
        min-width="50"
        align="center"
      >
        <template slot-scope="scope">
          <i
            class="el-icon-circle-check change"
            v-show="!scope.row.approve && !scope.row.reflect"
          ></i>
        </template>
      </el-table-column>
      <el-table-column
        :label="$locale('global.image')"
        prop="imageUrl"
        min-width="100"
        align="center"
      >
        <template slot-scope="scope">
          <el-image
            style="width: 80px; height: 80px"
            :src="scope.row.imageUrl"
            fit="cover"
          >
            <div slot="error" class="image-error-slot">
              <i class="el-icon-picture-outline"></i>
            </div>
          </el-image>
        </template>
      </el-table-column>
      <el-table-column
        :label="$locale('global.name')"
        prop="name"
        min-width="220"
        sortable="custom"
      ></el-table-column>
      <el-table-column
        :label="$locale('global.productCode')"
        prop="productCode"
        sortable
        min-width="120"
      ></el-table-column>
      <el-table-column
        column-key="groupName"
        :label="$locale('global.department')"
        prop="groupName"
        min-width="160"
        align="center"
        :filters="groupArr"
        :filtered-value="groupIds"
      ></el-table-column>
      <el-table-column
        :label="$locale('bookKeeping.journal.dept')"
        min-width="160"
      >
        <template slot-scope="scope">
          {{ getTrandeGroupName(scope.row.journalType )}}
        </template>
      </el-table-column>
      <el-table-column
        :label="$locale('global.unitPrice')"
        prop="price"
        min-width="110"
        sortable="custom"
      >
        <template slot-scope="scope">
          {{ scope.row.price === "" ? "" : "¥ " + currencyFormat(scope.row.price) }}
        </template>
      </el-table-column>
      <!-- <el-table-column
          label="在庫"
          prop="inventory"
          min-width="119"
          align="center"
        >
          <template slot-scope="scope">
            {{ scope.row.inventory === "" ? 0 : currencyFormat(scope.row.inventory) }}
          </template>
        </el-table-column> -->
      <el-table-column
        column-key="status"
        :label="$locale('global.status')"
        prop="publishObject[text]"
        min-width="120"
        align="center"
        :filters="[
          {
            text: this.$locale('global.selling'),
            value: 'RELEASE'
          },
          {
            text: this.$locale('global.updating'),
            value: 'SALESUPDATE'
          },
          {
            text: this.$locale('global.stopSelling'),
            value: 'RESERVE'
          }
        ]"
        :filtered-value="['RELEASE', 'SALESUPDATE', 'RESERVE']"
      >
        <template slot-scope="scope">
          <!-- <span :class="scope.row.publishObject['className']"></span> -->
          <i
            :class="
              scope.row.publish == 'RELEASE' ? 'status-btn' : 'status-btn grey'
            "
          ></i>
          {{ scope.row.publishObject["text"] }}
          <!-- {{publishStatus[scope.row.publish]}} -->
        </template>
      </el-table-column>
      <el-table-column :label="$locale('global.control')" align="center" min-width="140">
        <template slot-scope="scope">
          <div class="handle">
            <!-- <span>在庫変更</span>
							<span class="split">|</span> -->
            <!-- <a @click="openDialog('R', scope.row.id)">{{ $locale("global.detail") }}</a>
            <el-divider direction="vertical"></el-divider> -->
            <a @click="openDialog('E', scope.row.id)">{{ $locale("global.edit") }}</a>
            <el-divider direction="vertical"></el-divider>
            <a @click="deleteRow(scope.row.id, scope.row.name)">{{ $locale("global.delete") }}</a>
          </div>
        </template>
      </el-table-column>
    </el-table>
    <CommPagination
      :total="count"
      :curPage="currentPage"
      :pageSize="pageSize"
      @current-change="pageChange"
    />

    <!-- Dialog -->
    <el-dialog
      :visible.sync="isDialogVisible"
      width="980px"
      class="egl-dialog-elm channel-dialog"
      :close-on-click-modal="false"
      @close="closeDialog"
    >
      <div slot="title" class="dialog-title">
        <div class="tipsBox">
          <p>{{ dialogTitle }}</p>
          <el-tooltip :content="dialogTitle" placement="top">
            <span class="tipIcon"></span>
          </el-tooltip>
        </div>
      </div>

      <div class="dialog-content">
        <div class="tipsBox">
          <div class="form-module-tit">{{ $locale("global.basicInfo") }}</div>
          <el-tooltip :content="$locale('global.basicInfo')" placement="top">
            <span class="tipIcon"></span>
          </el-tooltip>
        </div>
        <el-form
          label-position="top"
          label-width="40px"
          :model="createForm"
          class="setForm"
          ref="setForm"
          :rules="rules"
          :disabled="isReadOnlyDialog"
        >
          <el-row>
            <el-col :span="12">
              <el-form-item :label="$locale('shop.barcode')" prop="barCode">
                <el-input
                  :placeholder="$locale('shop.plsEnterBarcode')"
                  v-model="createForm.barCode"
                />
              </el-form-item>
              <el-form-item :label="$locale('shop.productCode')" prop="productCode">
                <el-input :placeholder="$locale('shop.productCode.p')" v-model="createForm.productCode" />
              </el-form-item>
              <el-form-item :label="$locale('global.name')" prop="name">
                <el-input
                  :placeholder="$locale('form.plsEnterYourName')"
                  v-model="createForm.name"
                />
              </el-form-item>
              <el-form-item :label="$locale('global.price_taxIncluded')" prop="price">
                <el-input
                  :placeholder="$locale('form.plsEnterPrice')"
                  v-model.number="createForm.price"
                  maxlength="12"
                  @input="_debounce()"
                >
                  <template slot="prepend">¥</template>
                </el-input>
              </el-form-item>
              <el-row :gutter="10">
                <el-col :span="12">
                  <el-form-item :label="$locale('shop.taxDisplay')" prop="taxRate">
                    <TaxSelect v-model="createForm.taxRate" @change="priceChangeAction"></TaxSelect>
                  </el-form-item>
                </el-col>
                <el-col :span="12">
                  <el-form-item :label="$locale('shop.amount_excludingTax')" prop="productCost">
                    <el-input v-model="createForm.productCost" :disabled="true">
                      <template slot="prepend">¥</template>
                    </el-input>
                  </el-form-item>
                </el-col>
              </el-row>
            </el-col>
            <el-col :span="10" :offset="2">
              <el-form-item style="width: 100%;" :label="$locale('global.image') + $locale('shop.upload.tips')" prop="imageUrl" class="upload">
                <UploadContainer
                  :type="'B'"
                  :imageList="[createForm.imageUrl]"
                  @onSuccess="({response}) => uploadSuccess(response)"
                  @onDelete="deleteImg"
                ></UploadContainer>
              </el-form-item>
            </el-col>
          </el-row>

          <hr class="dotted" />

          <div class="tipsBox">
            <div class="form-module-tit">{{ $locale("shop.salesRelatedInfo") }}</div>
            <el-tooltip :content="$locale('shop.salesRelatedInfo')" placement="top">
              <span class="tipIcon"></span>
            </el-tooltip>
          </div>

          <el-row :gutter="10">
            <!-- <el-col :span="8">
              <el-form-item :label="$locale('global.salesDepartment')" prop="salesGroup.id">
                <el-select v-model="createForm.salesGroup.id">
                  <el-option
                    v-for="item in salesGroupArr"
                    :label="item.name"
                    :value="item.id"
                    :key="item.id"
                  ></el-option>
                </el-select>
              </el-form-item>
            </el-col> -->
            <el-col :span="10">
              <el-form-item :label="$locale('shop.productType')" prop="productType">
                <el-select v-model="createForm.productType" :disabled="true">
                  <el-option :label="$locale('global.purchase')" value="SALES_ITEM"></el-option>
                  <el-option :label="$locale('global.entrust')" value="CONSIGNMENT"></el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="10">
              <el-form-item :label="$locale('global.works')" prop="filmId">
                <el-select v-model="createForm.filmId" filterable clearable>
                  <el-option :label="$locale('global.none')" value=""></el-option>
                  <el-option
                    v-for="(item, idx) in filmArr"
                    :key="idx"
                    :label="item.name"
                    :value="item.id"
                  ></el-option>
                </el-select>
              </el-form-item>
            </el-col>
          </el-row>

          <hr class="dotted" />

          <div class="tipsBox">
            <div class="form-module-tit">{{ $locale("shop.couponSetting") }}</div>
            <el-tooltip :content="$locale('shop.couponSetting')" placement="top">
              <span class="tipIcon"></span>
            </el-tooltip>
          </div>

          <el-row>
            <el-col :span="8">
              <el-form-item :label="$locale('shop.unavailableCoupon')" prop="unavailableCoupons">
                <!-- <el-select
                  ref="couponSelect"
                  :multiple="couponType"
                  v-model="createForm.unavailableCoupons"
                  clearable
                >
                  <el-option
                    :label="$locale('global.none')"
                    value="none"
                    :disabled="noneCouponDisabled"
                  ></el-option>
                  <el-option
                    v-for="(item, idx) in couponArr"
                    :key="idx"
                    :label="item.name"
                    :value="item.id"
                    :disabled="couponOptionDisabled"
                  ></el-option>
                </el-select> -->
                <remote-select
                v-if="createForm.name || action === 'create'"
                v-model="createForm.unavailableCoupons"
                :formValue.sync="createForm.unavailableCoupons"
                :actionType="action"
                @selectAll="arr => form.unavailableCoupons = arr"
              ></remote-select>
              </el-form-item>
            </el-col>
          </el-row>

          <hr class="dotted" />

          <div class="tipsBox">
            <div class="form-module-tit">{{ $locale("shop.contentsSetting") }}</div>
            <el-tooltip :content="$locale('shop.contentsSetting')" placement="top">
              <span class="tipIcon"></span>
            </el-tooltip>
          </div>

          <el-tabs
            type="border-card"
            class="SetOptions"
            @tab-click="toggleTab"
            :value="curTab"
          >
            <el-tab-pane name="concession">
              <div
                slot="label"
                class="tabsTitle"
                :class="curTab === 'concession' && 'on'"
              >
                {{ $locale("sideMenu.shop.concession") }}
              </div>

                <el-table
                  :data="concessionList"
                  class="tabsTable"
                  ref="concessionTable"
                  @select="selectionChangeFn"
                  height="350"
                >
                  <el-table-column type="selection" width="50"></el-table-column>
                  <el-table-column
                    prop="name"
                    :label="$locale('global.name')"
                    width="200"
                  ></el-table-column>
                  <el-table-column
                    prop="floatingPrice"
                    :label="$locale('shop.priceAdjustment')+'（¥）'"
                    width="160"
                    align="center"
                  >
                    <template slot-scope="scope">
                      <el-form-item prop="floatingPrice">
                        <el-input v-model="scope.row.floatingPrice" />
                      </el-form-item>
                    </template>
                  </el-table-column>
                  <el-table-column prop="options" :label="$locale('global.option')">
                    <template slot-scope="scope">
                      {{ ingredientFormat(scope.row.options) }}
                    </template>
                  </el-table-column>
                  <el-table-column
                    prop="inventory"
                    :label="$locale('shop.stock')"
                  >
                    <template slot-scope="scope">{{ inventoryFormat(scope.row.inventory) }}</template>
                  </el-table-column>
                </el-table>

            </el-tab-pane>
            <el-tab-pane name="commercial">
              <div
                slot="label"
                class="tabsTitle"
                :class="curTab === 'commercial' && 'on'"
              >
                {{ $locale("global.commercial") }}
              </div>

                <el-table
                  :data="commercialList"
                  class="tabsTable"
                  ref="commercialTable"
                  @select="selectionChangeFn"
                  height="350"
                >
                  <el-table-column type="selection" width="50"></el-table-column>
                  <el-table-column
                    prop="name"
                    :label="$locale('global.name')"
                    width="200"
                  ></el-table-column>
                  <el-table-column
                    prop="floatingPrice"
                    :label="$locale('shop.priceAdjustment')+'（¥）'"
                    width="160"
                    align="center"
                  >
                    <template slot-scope="scope">
                      <el-form-item prop="floatingPrice">
                        <el-input v-model="scope.row.floatingPrice" />
                      </el-form-item>
                    </template>
                  </el-table-column>
                  <el-table-column prop="option" :label="$locale('global.option')">
                    <template slot-scope="scope">
                      {{ ingredientFormat(scope.row.options) }}
                    </template>
                  </el-table-column>
                  <el-table-column prop="inventory" :label="$locale('shop.stock')">
                    <template slot-scope="scope">{{ inventoryFormat(scope.row.inventory) }}</template>
                  </el-table-column>
                </el-table>

            </el-tab-pane>
          </el-tabs>

          <div class="tipsBox">
            <div class="form-module-tit">{{ $locale("shop.selectionRuleSetting") }}</div>
            <el-tooltip :content="$locale('shop.selectionRuleSetting')" placement="top">
              <span class="tipIcon"></span>
            </el-tooltip>
          </div>

          <el-row
            :gutter="10"
            v-for="(packageItem, idx) in createForm.items"
            :key="'packageItem_'+idx"
          >
            <el-col :span="8">
              <el-form-item
                :label="$locale('global.item')"
                :prop="`items[${idx}].selectedItems`"
                :rules="goodsPackageItemsRules"
              >
                <el-select
                  multiple
                  v-model="packageItem.selectedItems"
                >
                  <el-option
                    v-for="(option, idx) in optionCollection"
                    :key="'gpItem_'+idx"
                    :label="option.name"
                    :value="option.id"
                  ></el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="5">
              <el-form-item
                :label="$locale('shop.howToChoose')"
                :prop="`items[${idx}].rule`"
                :rules="goodsPackageItemsRules"
              >
                <el-select
                  v-model="packageItem.rule"
                >
                  <el-option
                    v-for="(item, idx) in methodArr"
                    :key="idx"
                    :label="item.label"
                    :value="item.value"
                  ></el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item label="アイテムタイトル" prop="itemTitle">
                <el-input v-model="packageItem.itemTitle" />
              </el-form-item>
            </el-col>
            <el-col :span="5">
              <div class="action" v-if="!isReadOnlyDialog">
                <i
                  class="el-icon-remove-outline"
                  v-if="createForm.items.length > 1"
                  @click="remove(idx)"
                ></i>
                <i
                  class="el-icon-circle-plus-outline"
                  @click="increase"
                  v-if="idx === createForm.items.length - 1"
                ></i>
              </div>
            </el-col>
          </el-row>

          <hr class="dotted" />

          <div class="tipsBox">
            <div class="form-module-tit">{{ $locale("shop.inventorySetting") }}</div>
            <el-tooltip :content="$locale('shop.set.autoSoldOutTips')" placement="top">
              <span class="tipIcon"></span>
            </el-tooltip>
          </div>

          <el-row>
            <el-col :span="8">
              <el-form-item :label="$locale('shop.autoSoldOut')" prop="useAutoSoldOut">
                <BoolSelect v-model="createForm.useAutoSoldOut" :optionObj="boolSelectObj"></BoolSelect>
              </el-form-item>
            </el-col>
          </el-row>

          <hr class="dotted" />

          <div class="tipsBox">
            <div class="form-module-tit">{{ $locale("global.dispRelatedSettings") }}</div>
            <el-tooltip :content="$locale('global.dispRelatedSettings')" placement="top">
              <span class="tipIcon"></span>
            </el-tooltip>
          </div>

          <el-form-item :label="$locale('global.hiddenSetting')" prop="displayOptions">
            <el-checkbox-group v-model="displayOptions">
              <el-checkbox-button label="POS">{{ $locale('global.POS') }}</el-checkbox-button>
              <el-checkbox-button label="SelfCashier">{{ $locale('global.selfCheckout') }}</el-checkbox-button>
            </el-checkbox-group>
          </el-form-item>

          <el-row :gutter="20">
            <el-col :span="8">
              <el-form-item
                :label="$locale('global.btnBackgroundColor') + '（' + $locale('global.POS') + '）'"
                prop="bgColor"
              >
                <ColorPicker v-model="createForm.bgColor" @change="clearFormValidate('bgColor')" />
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item
                :label="$locale('global.btnTextColor') + '（' + $locale('global.POS') + '）'"
                prop="fontColor"
              >
                <ColorPicker v-model="createForm.fontColor" @change="clearFormValidate('fontColor')" />
              </el-form-item>
            </el-col>
          </el-row>

          <el-row :gutter="20">
            <el-col :span="10">
              <el-form-item :label="$locale('form.displayPOS')">
                <el-select
                  v-model="createForm.groupId"
                  :placeholder="$locale('form.plsSelectGroupofSale_POS')"
                >
                  <el-option
                    v-for="(item, idx) in this.groupArr"
                    :key="idx"
                    :label="item.name"
                    :value="item.id"
                  ></el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="10">
              <el-form-item :label="$locale('global.displayOrder') + '（' + $locale('global.POS') + '）'" prop="sort">
                <el-input
                  v-model="createForm.sort"
                  :placeholder="$locale('form.plsEnterNumDispOrder_POS')"
                  maxlength="5"
                />
              </el-form-item>
            </el-col>
          </el-row>
          <el-row :gutter="20">
            <el-col :span="12">
              <el-form-item :label="$locale('shop.description')" prop="description" style="width: 100%;">
                <el-input
                  v-model="createForm.description"
                  type="textarea"
                ></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item :label="$locale('shop.recommend')" style="width: 100%;">
                <el-checkbox-group
                  v-model="checkboxGroup.sc"
                >
                  <el-checkbox label="recommend">{{ $locale("shop.recommend.sc") }}</el-checkbox>
                </el-checkbox-group>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row :gutter="10">
            <el-col :span="8">
              <el-form-item :label="$locale('global.status')">
                <el-select v-model="createForm.publish">
                  <el-option :label="$locale('global.selling')" value="RELEASE"></el-option>
                  <el-option :label="$locale('global.stopSelling')" value="RESERVE"></el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item :label="$locale('shop.kiosk.groups')" >
                <el-select v-model="createForm.cinemaDailySelective" >
                  <el-option v-for="item in cinemaDailys"
                      :label="item.name"
                      :value="item.id"
                      :key="item.id"/>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item :label="$locale('bookKeeping.journal.dept')+' ('+$locale('setting.pay.accgroup')+')'" >
                <el-select v-model="createForm.journalType">
                  <el-option v-for="item in tradeGroupList"
                    :label="item.name"
                    :key="item.id"
                    :value="item.id"
                  />
                </el-select>
              </el-form-item>
            </el-col>
          </el-row>

          <el-row>
            <el-col :span="24">
              <ApproveField v-model="createForm.approveDate" :formData="createForm" fieldName="approveDate" />
            </el-col>
          </el-row>
        </el-form>
      </div>

      <div slot="footer" class="dialog-footer" v-if="!isReadOnlyDialog">
        <el-row type="flex" justify="center">
          <el-col :span="6">
            <el-button
              @click="closeDialog"
              class="egl-btn-white"
            >
              {{ $locale("global.cancel") }}
            </el-button>
          </el-col>
          <el-col :span="6">
            <el-button
              @click="submitForm"
              class="egl-btn-yellow"
            >
              {{ $locale("global.confirm") }}
            </el-button>
          </el-col>
        </el-row>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import ApproveField from "@/components/common/ApproveField";
import { priceFormat as PriceFormat } from "../../utils/common";
import {
  getGroupListService,
  // getSalesGroupListService,
  getMovieList,
} from "@/helpers/service/api/common";
import {
  getGoodsPackageListService,
  getGoodsPackageDetailService,
  addGoodsPackageService,
  updateGoodsPackageService,
  delGoodsPackageService,
  approveGoodsPackageService,
} from "@/helpers/service/api/set";
import { getCouponTypeList } from "@/helpers/service/api/coupon";
import { getConcessionType } from "@/helpers/service/api/concession";
import { getCommercialType } from "@/helpers/service/api/commercial";
import { getListService } from "@/helpers/service/api/tradeGroup";
import tranfResData from "@/utils/tranfResData";
import countDownAlert from "@/utils/countDownAlert";
import { positiveNumValidator, hexColorValidator } from "@/utils/formFieldValidator";
import "@/assets/style/set.less";
import TaxSelect from "@/components/common/TaxSelect";
import BoolSelect from "@/components/common/BoolSelect";
import { taxOff } from "@/utils/math.js";
import { kioskOpts, kioskMaps } from "@/utils/common.js";
import ColorPicker from "@/components/common/ColorPicker";
import CommPagination from "@/components/common/CommPagination";
import UploadContainer from "@/components/common/UploadContainer";
import RemoteSelect from "@/components/common/RemoteSelect";
import { requestAll } from "@/helpers/service/axiosPlugin";
import { getCinemaDailyListService } from "@/helpers/service/api/theaterDailyShow.js";
import { decimal2 } from "@/utils/utils";
import { getCinemaDailyIdForName } from "@/utils/common";

export default {
  components: {
    CommPagination,
    ApproveField,
    TaxSelect,
    BoolSelect,
    ColorPicker,
    UploadContainer,
    RemoteSelect,
  },
  data() {
    return {
      action: "",
      cinemaDailys: [],
      kioskMaps,
      kioskOpts,
      tradeGroupList: [],
      tradeGroupkeyval:[],
      couponType: true,
      itemType: false,
      count: 0,
      searchValue: "",
      isDialogVisible: false,
      isDetailShow: false,
      isEditShow: false,
      publishStatus: {
        RELEASE: {
          text: this.$locale("global.selling"),
          className: "release"
        },
        RESERVE: {
          text: this.$locale("global.stopSelling"),
          className: "reserve"
        }
      },
      tableData: [],
      createForm: this.initFormData(),
      boolSelectObj: [
        { label: this.$locale("shop.option.utilize"), value: true },
        { label: this.$locale("shop.option.notUsed"), value: false },
      ],
      rules: {
        name: [
          {
            required: true,
            message: this.$locale("form.plsEnterYourName"),
            trigger: "blur"
          }
        ],
        price: [
          {
            required: true,
            message: this.$locale("form.plsEnterPrice"),
            trigger: "blur"
          },
          // {
          //   type: "number",
          //   message: this.$locale("form.mustFillInNum"),
          //   trigger: "blur",
          // }
        ],
        taxRate: [
          {
            required: true,
            message: this.$locale("shop.plsEnterTaxDisplay"),
            trigger: "blur"
          }
        ],
        productType: [
          {
            required: true,
            message: this.$locale("shop.plsSelectProductType"),
            trigger: "blur"
          }
        ],
        sort: [
          {
            validator: positiveNumValidator,
            trigger: "blur",
          }
        ],
        bgColor: [
          {
            validator: hexColorValidator,
            trigger: "blur",
          }
        ],
        fontColor: [
          {
            validator: hexColorValidator,
            trigger: "blur",
          }
        ],
      },
      headersObject: {
        Authorization: window.localStorage.getItem("token")
      },
      groupArr: [],
      groupIds: [],
      salesGroupArr: [],
      salesGroupIds: [],
      filmArr: [],
      curTab: "",
      concessionList: [],
      commercialList: [],
      methodArr: [
        {
          label: this.$locale("shop.anyOne"),
          value: "one"
        },
        {
          label: this.$locale("shop.eitherTwo"),
          value: "two"
        },
        {
          label: this.$locale("shop.anyThree"),
          value: "three"
        }
      ],
      couponArr: [],
      curId: "",
      sort: "",
      sortKey: "",
      dialogType: null, // {‘C = create' | 'R = readOnly' | 'E = edit'}
      cinemaId: window.localStorage.getItem("cinemaId"),
      currentPage: 0,
      pageSize: 10,
      displayOptions: [], //customize, check/uncheck displayPos|displaySelfCashier
      optionCollection: [], //customize, setup items.options dropdown list
      decimal2,
      checkboxGroup: {
        sc: false,
      },
    };
  },
  async created() {
    await this.getList();
    // await this.getFilmList();
    await this.getPackageItems();
    // await this.getCouponList();
    // await this.getTradeGroup();

    this._debounce = this.$_.debounce(this.priceChangeAction, 600, false);
  },
  mounted() {
    getCinemaDailyListService({ cinemaId: window.localStorage.getItem("cinemaId") }).then(res => {
      if (res.data && res.data.data.length > 0) {
        this.cinemaDailys = res.data.data;
      }
    });
  },
  computed: {
    couponOptionDisabled() {
      const { unavailableCoupons } = this.createForm;
      return unavailableCoupons.includes("none");
    },
    noneCouponDisabled() {
      const { unavailableCoupons } = this.createForm;
      return unavailableCoupons.length > 0 && !unavailableCoupons.includes("none");
    },
    dialogTitle() {
      if (this.dialogType !== "R") {
        return `${this.$locale("sideMenu.shop.set")}${this.$locale("global.create")} / ${this.$locale("global.edit")}`;
      }
      return `${this.$locale("sideMenu.shop.set")}${this.$locale("global.detail")}`;
    },
    getApproveItem() {
      if (this.tableData.length === 0) { return true; }

      const isDisabled = !this.tableData.find(item => item.approve === false && item.reflect === false);
      return isDisabled;
    },
    isReadOnlyDialog() {
      return this.dialogType === "R";
    },
    goodsPackageItemsRules() {
      return {
        required: this.optionCollection.length > 0,
        message: this.$locale("form.mandatoryField"),
        trigger: "change",
      };
    },
  },
  methods: {
    initFormData() {
      return {
        approve: false,
        barCode: "",
        bgColor: "#FFFFFF",
        cinemaId: this.cinemaId,
        displayPos: false,
        displaySelfCashier: false,
        filmId: "",
        fontColor: "#000000",
        groupId: "",
        id: "",
        imageUrl: "",
        inventory: 0,
        // isApprove: false,
        items: [ { itemTitle: "アイテム", options: [], rule: "one", selectedItems: [] } ],
        name: "",
        price: null,
        productCost: null,
        productType: "SALES_ITEM",
        publish: "RELEASE",
        cinemaDailySelective: "",
        salesGroup: { id: null, name: null },
        sort: null,
        taxRate: 0.1,
        unavailableCoupons: [],
        approveDate: this.$moment().startOf("day").valueOf(),
        description: "",
        useAutoSoldOut: false,
      };
    },
    getGroupList() {
      if (this.groupArr.length > 0) { return; }

      getGroupListService({
        cinemaId: this.cinemaId,
        type: "goodsPackage"
      }).then(res => {
        this.groupArr = res.data && res.data.length > 0 ? tranfResData(res.data) : [];
        this.groupArr.length > 0 && this.groupArr.forEach(group => {
          group.text = group.name;
          group.value = group.id;
        });
        this.groupArr = [{ id: "", name: this.$locale("global.none") }, ...this.groupArr];
      });
    },
    // getSalesList() {
    //   if (this.salesGroupArr.length > 0) { return; }

    //   getSalesGroupListService({
    //     cinemaId: this.cinemaId,
    //     type: "goodsPackage"
    //   }).then(res => {
    //     this.salesGroupArr = res.data.data;
    //     this.salesGroupArr.forEach(salesGroup => {
    //       salesGroup.text = salesGroup.name;
    //       salesGroup.value = salesGroup.id;
    //     });
    //   });
    // },
    getGoodsPackage(requestData) {
      const dataFormat = data => {
        data.forEach((idItem, idx) => {
          const _publish = idItem.publish;
          idItem.publishObject = this.publishStatus[_publish];
          this.groupArr.forEach(groupItem => {
            if (idItem.groupId === groupItem.id) {
              data[idx].groupName = groupItem.name;
            }
          });
        });
        return data;
      };

      getGoodsPackageListService({
        cinemaId: this.cinemaId,
        page: this.currentPage,
        pageSize: this.pageSize,
        approve: false,
        ...(this.sortKey ? { sortKey: this.sortKey } : {}),
        ...(this.sort ? { sort: this.sort } : {}),
        ...(this.publish ? { publish: this.publish } : {}),
        ...(this.groupIds ? { groupIds: this.groupIds } : {}),
        ...(this.salesGroupIds ? { salesGroupIds: this.salesGroupIds } : {}),
        ...(requestData? requestData : {}),
      }).then(res => {
        const resData = tranfResData(res.data);
        this.count = resData.count || 0;
        this.tableData = dataFormat(resData.data);
      });
    },
    getFilmList() {
      getMovieList({
        cinemaId: this.cinemaId,
        approve: true,
        page: 0,
        pageSize: 9999
      }).then(res => {
        this.filmArr = tranfResData(res.data.data);
        // this.filmArr = res.data.data;
      });
    },
    getList(data) {
      const process1 = this.getGroupList();
      // const process2 = this.getSalesList();

      Promise.all([ process1,
      // process2
      ]).then(() => {
        this.getGoodsPackage(data);
      });
    },
    getCouponList() {
      getCouponTypeList({
        cinemaId: this.cinemaId, page: 0, pageSize: 9999, approve: true
      }).then(res => {
        this.couponArr = tranfResData(res.data.data);
      });
    },
    getTradeGroup() {
      getListService({
        brandId: window.localStorage.getItem("brandId"),
      }).then(res => {
        this.tradeGroupList = res.data;
      });
    },
    getTrandeGroupName(id) {
      let index = this.tradeGroupList.findIndex(x => x.id === id);
      if(index < 0) {
        return "";
      }
      return this.tradeGroupList[index].name;
    },
    getPackageItems() {
      const queryString = `cinemaId=${this.cinemaId}&pageSize=9999&approve=true`;
      const requestParam = {
        cinemaId: this.cinemaId,
        approve: true,
        page: 0,
        pageSize: 9999,
      };
    },
    sortChange(column) {
      if (!column) { return; }

      const sortObject = {
        descending: "DESC",
        ascending: "ASC"
      };

      if (column.prop) {
        this.sortKey = column.prop;
      } else {
        this.sortKey = "";
      }

      if (column.order) {
        this.sort = sortObject[column.order];
      } else {
        this.sortKey = "";
        this.sort = "";
      }

      this.getList();
    },
    pageChange(value) {
      if (!value) { return; }

      this.currentPage = value - 1;
      this.getList();
    },
    // Display only — keep row.inventory numeric, it is sent back in createSet (DEV-15126).
    inventoryFormat(value) {
      if (value === null || value === undefined || value === "") { return ""; }
      const [ int, dec ] = String(value).split(".");
      return int.replace(/\B(?=(\d{3})+(?!\d))/g, ",") + (dec === undefined ? "" : "." + dec);
    },
    currencyFormat(value, num) {
      return PriceFormat(value, num);
    },
    filterHandler(column) {
      if (!column) { return; }

      if (column.status) {
        [ this.publish ] = column.status;
      } else if (column.groupName) {
        this.groupIds = column.groupName;
      } else if (column.salesGroupName) {
        this.salesGroupIds = column.salesGroupName;
      }

      this.getList();
    },
    search(value) {
      const rData = { name: value };
      this.getList(rData);
    },
    uploadSuccess(res) {
      if (res.success) {
        this.createForm.imageUrl = res.data;
      }
    },
    deleteImg() {
      this.createForm.imageUrl = "";
    },
    toggleTab(type) {
      this.curTab = type.name;
    },
    ingredientFormat(arr) {
      let str = "";
      if (!arr || arr.length === 0 || arr[0].name === "") {
        return "/";
      }

      for (let i = 0; i < arr.length; i++) {
        if (i === arr.length - 1) {
          str += arr[i].name;
        } else {
          str += arr[i].name + "/";
        }
      }
      return str;
    },
    selectionChangeFn(selection) {
      let currentSelection = [];
      const otherSelection = [ ...this.optionCollection.filter(option => option.type !== this.curTab) ];

      selection.forEach(selected => {
        currentSelection.push({
          id: selected.id,
          name: selected.name,
          type: this.curTab,
        });
      });
      this.optionCollection = [...currentSelection, ...otherSelection];

      let currentIds = [];
      this.optionCollection.forEach(option => {
        currentIds.push(option.id);
      });

      this.createForm.items.forEach((item, i) => item.selectedItems.forEach((selected, j) => {
        if (!currentIds.includes(selected)) {
          this.createForm.items[i].selectedItems.splice(j, 1);
        }
      }));
    },
    submitForm() {
      this.$refs["setForm"].validate(valid => {
        if (valid) {
          this.createSet(this.dialogType === "E");
        } else {
          setTimeout(() => {
            const isError = document.getElementsByClassName("is-error");
            isError[0].querySelector("input").focus();
          }, 100);
          // this.$alert(this.$locale("form.plsFillInAllRequiredFields"));
          return false;
        }
      });
    },
    showApprove() {
      this.$refs.approve.toggleApprove();
    },
    approve_fn() {
      let confirmHtml = `<i class="egl-confirm-question">?</i><span class="result-text">${this.$locale("global.approveAll")}</span>`;

      this.$confirm(confirmHtml, "", {
        dangerouslyUseHTMLString: true,
        showClose: false,
        showCancelButton: true,
        cancelButtonClass: "egl-btn-white",
        cancelButtonText: this.$locale("global.cancel"),
        showConfirmButton: true,
        confirmButtonClass: "egl-btn-yellow",
        confirmButtonText: this.$locale("global.approve"),
        customClass: "egl-confirm",
        closeOnClickModal: false
      })
        .then(() => {
          approveGoodsPackageService({
            cinemaId: this.cinemaId
          }).then(() => {
            this.getList();
          });
        });
    },
    increase() {
      this.createForm.items.push({ options: [], rule: "one", selectedItems: [] });
    },
    remove(index) {
      this.createForm.items.splice(index, 1);
    },
    openDialog(type, id) {
      this.curId = id;
      this.dialogType = type;
      const typeMapping = {
        C: "create",
        R: "readOnly",
        E: "edit"
      };
      this.action = typeMapping[type];
      const requestParam = {
        cinemaId: this.cinemaId,
        approve: true,
        page: 0,
        pageSize: 9999,
      };
      const formatInventoryString = targetObj => {
        const { options, inventory } = targetObj;
        if (!options || options.length === 0) { return this.currencyFormat(inventory, 2); }

        let str = "";
        options.forEach((option, index) => {
          if (option.name) {
            str += `${option.name}: ${this.currencyFormat(option.inventory, 2)}`;

            if (index < options.length - 1) {
              str += "/";
            }
          } else {
            str = this.currencyFormat(inventory, 2);
          }
        });

        return str;
      };
      const formatTabTableData = (tableData, dataType) => {
        const resultArray = [];
        tableData.forEach(item => {
          resultArray.push({
            id: item.id,
            name: item.name,
            floatingPrice: item.floatingPrice || "",
            options: item.options,
            inventory: item.inventory,
            type: dataType,
            optionTitle: item.optionTitle
          });
        });
        return resultArray;
      };
      if (this.concessionList.length === 0 || this.commercialList.length === 0) {
        requestAll([
          this.concessionList.length === 0 ? getConcessionType(requestParam) : null,
          this.commercialList.length === 0 ? getCommercialType(requestParam) : null,
        ]).then(res => {
          if (res[0] && res[0].data) {
            const resData = tranfResData(res[0].data.data);
            this.concessionList = formatTabTableData(resData, "concession");
          }
          if (res[1] && res[1].data) {
            const resData = tranfResData(res[1].data.data);
            this.commercialList = formatTabTableData(resData, "commercial");
          }
        });
      }
      if (type !== "C") {
        getGoodsPackageDetailService({ id }).then(res => {
          const resData = tranfResData(res.data);
          const { displayPos, displaySelfCashier, } = resData;

          this.displayOptions = [
            ...(!displayPos ? [ "POS" ] : []),
            ...(!displaySelfCashier ? [ "SelfCashier" ] : []),
          ];

          // 旧数据没有该字段(null)，按OFF显示
          this.createForm = { ...resData, useAutoSoldOut: resData.useAutoSoldOut === true };
          this.checkboxGroup.sc = resData.recommend;

          const arrayMapping = {
            concession: this.concessionList,
            commercial : this.commercialList,
          };

          const dataCopy = tranfResData(this.createForm.items);
          dataCopy.forEach(goodsItem => {
            /*
            * Add "selectedItems" array for display goods package item dropdown list.
            * Note: data source from "items.options "field.
            */
            goodsItem.selectedItems = [];

            if (goodsItem.options && goodsItem.options.length > 0) {
              goodsItem.options.forEach(option => {
                const targetArray = arrayMapping[option.type] || [];
                // Add "floatingPrice" field to concession/commercial list table.
                targetArray.forEach((list, i) => {
                  if (option.goodsId === list.id) {
                    targetArray[i].floatingPrice = option.floatingPrice;
                  }
                });

                goodsItem.selectedItems.push(option.goodsId);
                // Setup a array object, supply options for goods package item dropdown.
                if (!this.optionCollection.find(existOption => existOption && existOption.id === option.goodsId)) {
                  this.optionCollection.push({
                    id: option.goodsId,
                    name: option.name,
                    type: option.type,
                  });
                }
              });
            }
          });
          this.createForm.items = [ ...dataCopy ];
          this.isDialogVisible = true;
          this.toggleTab({ name: "concession" });

          this.$nextTick(() => {
            this.autoChooseOptions();
          });
        });
      } else {
        this.createForm = this.initFormData();

        this.concessionList.forEach(_list => {
          _list.floatingPrice = "";
        });

        this.commercialList.forEach(_list => {
          _list.floatingPrice = "";
        });

        this.isDialogVisible = true;
        this.toggleTab({ name: "concession" });
      }
    },
    closeDialog() {
      if (this.$refs["concessionTable"]) {
        this.$refs["concessionTable"].clearSelection();
      }
      if (this.$refs["commercialTable"]) {
        this.$refs["commercialTable"].clearSelection();
      }

      this.$refs["setForm"].resetFields();
      this.createForm = this.initFormData();
      this.isDialogVisible = false;
      this.optionCollection = [];
      this.curTab = "";
      this.action = "";
    },
    createSet(isUpdate) {
      const fullList = [
        ...this.concessionList,
        ...this.commercialList,
      ];
      const { salesGroup, items } = this.createForm;

      /**
       * Request data formatted handling
       */
      const targetGroup = this.salesGroupArr && this.salesGroupArr.find(group => group.id === salesGroup.id) || {};
      this.createForm.displayPos = !this.displayOptions.includes("POS");
      this.createForm.displaySelfCashier = !this.displayOptions.includes("SelfCashier");

      const dataCopy = tranfResData(items);
      dataCopy.forEach(item => {
        item.options = [];

        item.selectedItems.forEach(selectedId => {
          const [ target ] = fullList.filter(list => list.id === selectedId);

          item.options.push({
            ...target,
            goodsId: selectedId,
            optionGroups: target.options,
            floatingPrice: target.floatingPrice ? target.floatingPrice : 0,
          });
        });
      });
      this.createForm.items = [ ...dataCopy ];

      const requestParam = {
        goodsPackageInfo: {
          ...(isUpdate ? { id: this.curId } : {}),
          ...this.createForm,
          // cinemaId: this.cinemaId,
          salesGroup: {
            cinemaId: this.cinemaId,
            id: targetGroup.id,
            name: targetGroup.name,
          },
          recommend: this.checkboxGroup.sc
        }
      };

      const requestScuessFn = successfulText => {
        this.closeDialog();
        this.countDown(successfulText);
      };

      if (!isUpdate) {
        addGoodsPackageService(requestParam).then(() => {
          requestScuessFn(this.$locale("global.createSuccessfully"));
        });
      } else {
        updateGoodsPackageService(requestParam).then(() => {
          requestScuessFn(this.$locale("global.updateSuccessfully"));
        });
      }
      this.action = "";
    },
    deleteRow(id, name) {
      // const that = this;
      // let name = '';
      let confirmHtml = "";
      confirmHtml = `<i class="egl-confirm-question">?</i><span class="result-text">${this.$locale("global.delete")} ${name}?</span>`;
      this.$confirm(confirmHtml, "", {
        dangerouslyUseHTMLString: true,
        showClose: false,
        showCancelButton: true,
        cancelButtonClass: "egl-btn-white",
        cancelButtonText: this.$locale("global.cancel"),
        showConfirmButton: true,
        confirmButtonClass: "egl-btn-yellow",
        confirmButtonText: this.$locale("global.delete"),
        customClass: "egl-confirm",
        closeOnClickModal: false
      })
        .then(() => {
          delGoodsPackageService({ id }).then(() => {
            this.countDown(this.$locale("global.deleteSuccessfully"));
          });
        });
    },
    countDown(str) {
      countDownAlert({
        content: str,
        callback: () => {
          this.getList();
        }
      });
    },
    ruleMapping(rule) {
      const mapping = {
        "one": 1,
        "two": 2,
        "three": 3,
      };

      return mapping[rule] || 0;
    },
    priceChangeAction() {
      let roundSetting = window.localStorage.getItem("round");
      const { taxRate, price } = this.createForm;
      // this.createForm.productCost = taxRate > 0 ? Math.floor((price / ((1 + taxRate) * 10) * 100 * 10) / 100) : price;
      this.createForm.productCost  = taxOff(price, taxRate, roundSetting);
    },
    autoChooseOptions() {
      if (!this.$refs[ "concessionTable"] || !this.$refs[ "commercialTable"]) { return; }

      const currentTab = this.curTab || "concession";
      const targetTableData = this.optionCollection.filter(option => option.type === currentTab);
      const targetRef = this.$refs[`${currentTab}Table`];
      const dataSource = currentTab === "concession" ? this.concessionList : this.commercialList;

      targetTableData.forEach(selection => {
        const currentIndex = dataSource.findIndex(list => list.id === selection.id);
        targetRef.toggleRowSelection(dataSource[currentIndex], true);
      });
    },
    clearFormValidate(fieldName) {
      if (fieldName) {
        this.$refs.setForm.clearValidate(fieldName);
      } else {
        this.$refs.setForm.clearValidate();
      }
    },
    // ruleChangeAction(value, index) {
    //   const limitCount = this.ruleMapping(value);
    //   const targetOptions = this.createForm.items[index];

    //   if (limitCount < targetOptions.selectedItems.length) {
    //     targetOptions.selectedItems.pop();
    //     targetOptions.options.pop();
    //   }
    // },
  },
  watch: {
    curTab() {
      this.autoChooseOptions();
    },
    optionCollection(collenction) {
      if (collenction.length === 0) {
        this.createForm.items.forEach((item, i) => {
          const currentProp = `items[${i}].selectedItems`;
          this.clearFormValidate(currentProp);
        });
      }
    },
    isDialogVisible(val) {
      if (val && this.action === "create") {
        this.createForm.cinemaDailySelective = getCinemaDailyIdForName(this.cinemaDailys);
      }
      if (val && this.tradeGroupList.length === 0) {
        this.getTradeGroup();
      }
    }
  },
};
</script>

